import { gql } from "@apollo/client";

const CONFIG_QUERY = {
	GET_ARCHIVE_CONFIG_VALUE: gql`
		{
			getOneConfig(configKey: "autoArchiveReportCount") {
				configValue
			}
		}
	`,
	UPDATE_ARCHIVE_CONFIG_VALUE: gql`
		mutation ($configValue: String!) {
			upsertConfig(
				configValue: $configValue
				configKey: "autoArchiveReportCount"
			) {
				configValue
				configKey
			}
		}
	`,
	GET_DISABLE_CONFIG_VALUE: gql`
		{
			getOneConfig(configKey: "autoDisableWarningCount") {
				configValue
			}
		}
	`,
	UPDATE_DISABLE_CONFIG_VALUE: gql`
		mutation ($configValue: String!) {
			upsertConfig(
				configValue: $configValue
				configKey: "autoDisableWarningCount"
			) {
				configValue
				configKey
			}
		}
	`,
};
export default CONFIG_QUERY;
